<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <template v-slot:activator="{attrs}">
        <v-btn 
          text 
          class="mx-2" 
          fab 
          dark 
          color="primary"
          v-bind="attrs"
          @click="initDialog"
        >
          <v-icon dark>mdi-pencil</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Business Profile</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="onSave">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container fluid>
           <BusinessDetailsEditor :bus="bus" ref="businessDetailsEditor" />   
        </v-container>
      </v-card>
    </v-dialog>
</template>
<script>
import Vue from 'vue';
import BusinessDetailsEditor from './BusinessDetailsEditor'
export default {
    name: 'AddEditBusinessDetailsDialog',
    components: {
    BusinessDetailsEditor,
  }, 
    data () {
      return {
        dialog: false,  
        bus: new Vue(),      
      }
    },
    methods: {
      initDialog() {
        this.bus.$emit('initEditor');
        this.dialog=true;
      },
      async onSave() {
        await this.$refs.businessDetailsEditor.onSave();
        this.dialog = false;
      }
    },
  }
</script>